import { PersonalizationValue } from "@dots-projects/types";
import { Controller } from "react-hook-form";
import { Select } from "antd";
import React from "react";
const { Option } = Select;

// Regex to get value between {{ and }}
// export const VARIABLE_REGEX = /(?<=\{\{)([^{]*?)(?=\}\})/;  chenged because it's not compatible with safari browsers
export const VARIABLE_REGEX = /{{(.*?)}}/;

type TriggerEditorVariablesSelectorProps = {
  control: any;
  readOnly: any;
  defaultValue: string | null;
  triggerVariables: PersonalizationValue[];
  fieldName: string;
  placeholder?: string;
};

export function TriggerEditorVariablesSelector({
  triggerVariables,
  defaultValue,
  control,
  readOnly,
  fieldName,
  placeholder,
}: TriggerEditorVariablesSelectorProps) {
  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field }) => {
        const regexDefaultValue = defaultValue?.match(VARIABLE_REGEX);
        let defaultVariableValue;
        if (regexDefaultValue) {
          //Set prestine default value after removing {{}}
          defaultVariableValue = regexDefaultValue[1];
        } else {
          defaultVariableValue = defaultValue;
        }

        return (
          <>
            <Select
              disabled={readOnly}
              showSearch
              placeholder={"Select user response"}
              onChange={field.onChange}
              defaultValue={defaultVariableValue || null}
            >
              <Option key={-1} value={-1} name="" disabled>
                {placeholder}
              </Option>
              {/*Remove annotation variables*/}
              {triggerVariables
                .filter((insertVariable) => !insertVariable.id.includes("@"))
                .map((insertVariable) => {
                  return (
                    <Option
                      key={insertVariable.id}
                      value={insertVariable.id}
                      name={insertVariable.id}
                      id={insertVariable.id}
                    >
                      {insertVariable.userText}
                    </Option>
                  );
                })}
            </Select>
          </>
        );
      }}
    />
  );
}
